import React from "react";
import clsx from "clsx";
import { IonButton, IonIcon, IonImg } from "@ionic/react";

import Popover from "../../atoms/Popover";
import smileIcon from "../../assets/icons/smile.svg";
import closeNoCircleIcon from "../../assets/icons/close_no_circle.svg";
import { sortVolStamps } from "../../libs/stamp";
import type { Stamp } from "../../libs/stamp";

import styles from "./StampSelector.module.scss";

type Props = {
  stamps: Stamp[];
  onSelect: (stamp: Stamp) => void;
};

type TabKey = "vol" | "normal";

export default function StampSelector(props: Props) {
  const popover = React.useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<TabKey>("vol");

  const tabs = [
    {
      key: "vol" as TabKey,
      label: "vol.1〜vol.7のスタンプ",
      stamps: sortVolStamps(
        props.stamps.filter(stamp => stamp.category.startsWith("vol")),
      ),
    },
    {
      key: "normal" as TabKey,
      label: "ノーマルスタンプ",
      stamps: props.stamps.filter(stamp => stamp.category === "normal"),
    },
  ].filter(tab => tab.stamps.length > 0);
  const currentTab = tabs.find(tab => tab.key === activeTab) ?? tabs[0];

  const selectStamp = (stamp: Stamp) => {
    setPopoverOpen(false);
    props.onSelect(stamp);
  };

  const handleClick = (e: React.MouseEvent) => {
    if (popover === null || popover.current == null) {
      return;
    }
    popover.current!.event = e;
    setPopoverOpen(true);
  };

  return (
    <>
      <IonButton fill="clear" onClick={handleClick}>
        <IonIcon icon={smileIcon} />
      </IonButton>
      <Popover
        ref={popover}
        isOpen={popoverOpen}
        onDidDismiss={() => setPopoverOpen(false)}
        side="top"
        alignment="end"
        arrow={false}
        hideCloseButton
        className={styles.stampPopover}
      >
        <div className={styles.panel}>
          <div className={styles.tabBar}>
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                aria-label={tab.label}
                className={clsx(
                  styles.tabButton,
                  currentTab?.key === tab.key && styles.tabButtonActive,
                )}
                onClick={() => setActiveTab(tab.key)}
              >
                <img src={tab.stamps[0].image} alt="" />
              </button>
            ))}
            <button
              type="button"
              aria-label="閉じる"
              className={styles.closeButton}
              onClick={() => setPopoverOpen(false)}
            >
              <IonIcon icon={closeNoCircleIcon} />
            </button>
          </div>
          {tabs.length === 0 ? (
            <div className={styles.empty}>
              スタンプを読み込めませんでした。時間をおいて再度お試しください
            </div>
          ) : (
            <div className={styles.grid}>
              {(currentTab ? currentTab.stamps : []).map(stamp => (
                <IonImg
                  key={stamp.id}
                  src={stamp.image}
                  alt={stamp.name}
                  className={styles.stampCell}
                  onClick={() => selectStamp(stamp)}
                />
              ))}
            </div>
          )}
        </div>
      </Popover>
    </>
  );
}
